var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.137,
    height: 15.012,
    viewBox: "0 0 16.137 15.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "misuse-outline",
    transform: "translate(-3.062 -3.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5582",
    "data-name": "Pfad 5582",
    d: "M10.319,2.25c-4.5,0-8.069,3.324-8.069,7.506s3.573,7.506,8.069,7.506,8.069-3.324,8.069-7.506S14.814,2.25,10.319,2.25Zm0,13.94A6.708,6.708,0,0,1,3.4,9.756a6.708,6.708,0,0,1,6.916-6.434,6.708,6.708,0,0,1,6.916,6.434A6.708,6.708,0,0,1,10.319,16.19Z",
    transform: "translate(0.812 0.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5583",
    "data-name": "Pfad 5583",
    d: "M15.014,15.455,12.885,13.4l-2.129,2.056-.631-.609,2.129-2.056-2.129-2.056.631-.609,2.129,2.056,2.129-2.056.631.609L13.515,12.79l2.129,2.056Z",
    transform: "translate(-1.754 -2.192)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.49cd948d50c40450660f40768d031ac9.svg";
export { ForwardRef as ReactComponent };